
/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';
const FormLabel = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domInputTextarea: $('.wpcf7-form input, .wpcf7-form textarea, .login-block__input input, .form-row input, .checkout-form__payment-tab-box-form-wrap input, .address__form-wrap input'),
	$domCF7: $('.wpcf7-form, .woocommerce-form-login, .register-form, .lost_reset_password, .woocommerce-checkout, .checkout-form__payment-tab-box-form, .address__form, .woocommerce-address-fields__field-wrapper, .woocommerce-form-login, .single-product__different-size-form'),
	slWrapperInput: '.contact-us__form-wrap, .login-block__input, .form-row, .checkout-form__payment-tab-box-form-wrap',
	slInputLabel: '.contact-us__form-wrap-label, .login__input-label, label, .checkout-form__payment-tab-box-form-wrap-label',
	slInputControl: '.wpcf7-form-control',
	classMoved: 'is-moved',
	formSelector: $('.contact-us__form'),

	/** @description Initialize */
	init: function() {
		setTimeout(() => {
			$('.password-input .woocommerce-Input').unwrap();
			$('.woocommerce-Input--text:not(:placeholder-shown)~.login__input-label').addClass(FormLabel.classMoved);
		}, 300);
		this.formMove();
		if(!FormLabel.formSelector.hasClass('added-autocomplete')){
			this.formAutofill();
		}
		const woocommerceEditAddressElements = $('.woocommerce-edit-address');
		const woocommerceCheckoutElements = $('.woocommerce-checkout');
		// Using a timeout because the .add-addresses__holder element gets rendered a little late
		// therefore we can't check if the element exists or not on load
		setTimeout(() => {
			$(document).ready(function() {
				if (woocommerceCheckoutElements.length > 0) {
					const selectedValuesBillingState = $('#billing_state').val();
					if (selectedValuesBillingState && selectedValuesBillingState !== null && selectedValuesBillingState.length > 0) {
						$('#billing_state_field label').addClass('is-moved');
					} else {
						$('#billing_state_field label').removeClass('is-moved');
					}
					const selectedValuesShippingState = $('#shipping_state').val();
					if (selectedValuesShippingState && selectedValuesShippingState !== null && selectedValuesShippingState.length > 0) {
						$('#shipping_state label').addClass('is-moved');
					} else {
						$('#shipping_state label').removeClass('is-moved');
					}
					if($('#billing_last_name_field input').length) {
						if($('#billing_last_name_field input').val()) {
							$('#billing_last_name_field label').addClass('is-moved');
						} else {
							$('#billing_last_name_field label').removeClass('is-moved');
						}
					}
					if($('#billing_first_name_field input').length) {
						if($('#billing_first_name_field input').val()) {
							$('#billing_first_name_field label').addClass('is-moved');
						} else {
							$('#billing_first_name_field label').removeClass('is-moved');
						}
					}
					if($('#billing_email_field input').length) {
						if($('#billing_email_field input').val()) {
							$('#billing_email_field label').addClass('is-moved');
						} else {
							$('#billing_email_field label').removeClass('is-moved');
						}
					}
					if($('#account_password_field input').length) {
						if($('#account_password_field input').val()) {
							$('#account_password_field label').addClass('is-moved');
						} else {
							$('#account_password_field label').removeClass('is-moved');
						}
					}
					if($('#billing_phone_field input').length) {
						if($('#billing_phone_field input').val()) {
							$('#billing_phone_field label').addClass('is-moved');
						} else {
							$('#billing_phone_field label').removeClass('is-moved');
						}
					}
					if($('#billing_company_field input').length) {
						if($('#billing_company_field input').val()) {
							$('#billing_company_field label').addClass('is-moved');
						} else {
							$('#billing_company_field label').removeClass('is-moved');
						}
					}
					if($('#billing_address_1_field_google input').length) {
						if($('#billing_address_1_field_google input').val()) {
							$('#billing_address_1_field_google label').addClass('is-moved');
						} else {
							$('#billing_address_1_field_google label').removeClass('is-moved');
						}
					}
					if($('#billing_city_field input').length) {
						if($('#billing_city_field input').val()) {
							$('#billing_city_field label').addClass('is-moved');
						} else {
							$('#billing_city_field label').removeClass('is-moved');
						}
					}
					if($('#billing_address_2_field input').length) {
						if($('#billing_address_2_field input').val()) {
							$('#billing_address_2_field label').addClass('is-moved');
						} else {
							$('#billing_address_2_field label').removeClass('is-moved');
						}
					}
					if($('#billing_postcode_field input').length) {
						if($('#billing_postcode_field input').val()) {
							$('#billing_postcode_field label').addClass('is-moved');
						} else {
							$('#billing_postcode_field label').removeClass('is-moved');
						}
					}
				}
			});
			// if (woocommerceEditAddressElements.length > 0) {
			// 	if (!$('.add-addresses__holder').length) {
			// 		const selectedValues = $('select').val();
			// 		if (selectedValues && selectedValues !== null && selectedValues.length > 0) {
			// 			$('#shipping_state_field label').addClass('is-moved');
			// 			$('#billing_country_field label').addClass('is-moved');
			// 			$('#billing_state_field label').addClass('is-moved');
			// 		} else {
			// 			$('#shipping_state_field label').removeClass('is-moved');
			// 			$('#billing_country_field label').removeClass('is-moved');
			// 			$('#billing_state_field label').removeClass('is-moved');
			// 			// $('#shipping_country_field label').removeClass('is-moved');
			// 		}
			// 	}
			// }

			$('#shipping_country_field label').addClass('is-moved');
			if($('#billing_state_field input').length) {
				if($('#billing_state_field input').val()) {
					$('#billing_state_field label').addClass('is-moved');
				} else {
					$('#billing_state_field label').removeClass('is-moved');
				}
			}
			if($('#shipping_state_field input').length) {
				if($('#shipping_state_field input').val()) {
					$('#shipping_state_field label').addClass('is-moved');
				} else {
					$('#shipping_state_field label').removeClass('is-moved');
				}
			}
			if (woocommerceCheckoutElements.length > 0) {
				const selectedValuesBilling = $('#billing_country').val();
				if(selectedValuesBilling) {
					if (selectedValuesBilling.length > 0) {
						$('#billing_country_field label').addClass('is-moved');
					} else {
						$('#billing_country_field label').removeClass('is-moved');
					}
					const selectedValuesShipping = $('#shipping_country').val();
					if (selectedValuesShipping !== null && selectedValuesShipping.length > 0) {
						$('#shipping_country_field label').addClass('is-moved');
					} else {
						$('#shipping_country_field label').removeClass('is-moved');
					}
				}
			}
			jQuery('body').on('update_checkout', function() {
				const selectedValuesBilling = $('#billing_country').val();
				if (selectedValuesBilling && selectedValuesBilling !== null && selectedValuesBilling.length > 0) {
					$('#billing_country label').addClass('is-moved');
				} else {
					$('#billing_country label').removeClass('is-moved');
				}
				const selectedValuesBillingState = $('#billing_state').val();
				if (selectedValuesBillingState && selectedValuesBillingState !== null && selectedValuesBillingState.length > 0) {
					$('#billing_state_field label').addClass('is-moved');
				} else {
					$('#billing_state_field label').removeClass('is-moved');
				}
				const selectedValuesShipping = $('#shipping_country').val();
				if (selectedValuesShipping && selectedValuesShipping !== null && selectedValuesShipping.length > 0) {
					$('#shipping_country label').addClass('is-moved');
				} else {
					$('#shipping_country label').removeClass('is-moved');
				}
				const selectedValuesShippingState = $('#shipping_state').val();
				if (selectedValuesShippingState && selectedValuesShippingState !== null && selectedValuesShippingState.length > 0) {
					$('#shipping_state_field label').addClass('is-moved');
				} else {
					$('#shipping_state_field label').removeClass('is-moved');
				}
				if($('#billing_state_field input').length) {
					if($('#billing_state_field input').val()) {
						$('#billing_state_field input').parent().find('label').addClass('is-moved');
					} else {
						$('#billing_state_field input').parent().find('label').removeClass('is-moved');
					}
				}
				if($('#shipping_state_field input').length) {
					if($('#shipping_state_field input').val()) {
						$('#shipping_state_field input').parent().find('label').addClass('is-moved');
					} else {
						$('#shipping_state_field input').parent().find('label').removeClass('is-moved');
					}
				}
				const billingPhone = $('#billing_phone').val();
				if (billingPhone && billingPhone !== null && billingPhone.length > 0) {
					$('#billing_phone_field label').addClass('is-moved')
				} else {
					$('#billing_phone_field label').removeClass('is-moved');
				}
				if($('#billing_last_name_field input').length) {
					if($('#billing_last_name_field input').val()) {
						$('#billing_last_name_field label').addClass('is-moved');
					} else {
						$('#billing_last_name_field label').removeClass('is-moved');
					}
				}
				if($('#billing_first_name_field input').length) {
					if($('#billing_first_name_field input').val()) {
						$('#billing_first_name_field label').addClass('is-moved');
					} else {
						$('#billing_first_name_field label').removeClass('is-moved');
					}
				}
				if($('#billing_email_field input').length) {
					if($('#billing_email_field input').val()) {
						$('#billing_email_field label').addClass('is-moved');
					} else {
						$('#billing_email_field label').removeClass('is-moved');
					}
				}
				if($('#account_password_field input').length) {
					if($('#account_password_field input').val()) {
						$('#account_password_field label').addClass('is-moved');
					} else {
						$('#account_password_field label').removeClass('is-moved');
					}
				}
				if($('#billing_phone_field input').length) {
					if($('#billing_phone_field input').val()) {
						$('#billing_phone_field label').addClass('is-moved');
					} else {
						$('#billing_phone_field label').removeClass('is-moved');
					}
				}
				if($('#billing_company_field input').length) {
					if($('#billing_company_field input').val()) {
						$('#billing_company_field label').addClass('is-moved');
					} else {
						$('#billing_company_field label').removeClass('is-moved');
					}
				}
				if($('#billing_address_1_field_google input').length) {
					if($('#billing_address_1_field_google input').val()) {
						$('#billing_address_1_field_google label').addClass('is-moved');
					} else {
						$('#billing_address_1_field_google label').removeClass('is-moved');
					}
				}
				if($('#billing_city_field input').length) {
					if($('#billing_city_field input').val()) {
						$('#billing_city_field label').addClass('is-moved');
					} else {
						$('#billing_city_field label').removeClass('is-moved');
					}
				}
				if($('#billing_address_2_field input').length) {
					if($('#billing_address_2_field input').val()) {
						$('#billing_address_2_field label').addClass('is-moved');
					} else {
						$('#billing_address_2_field label').removeClass('is-moved');
					}
				}
				if($('#billing_postcode_field input').length) {
					if($('#billing_postcode_field input').val()) {
						$('#billing_postcode_field label').addClass('is-moved');
					} else {
						$('#billing_postcode_field label').removeClass('is-moved');
					}
				}
			});
			if($('.contact-us__form-wrap--pass #password_current').length) {
				if($('.contact-us__form-wrap--pass #password_current').val()) {
					$('.contact-us__form-wrap--pass label').addClass('is-moved');
				} else {
					$('.contact-us__form-wrap--pass label').removeClass('is-moved');
				}
			}
		}, 500);
		$(document).ready(function($) {
			if ($('body').hasClass('woocommerce-account')) {
				$('input').each(function() {
					const label = $('label[for="' + $(this).attr('id') + '"]').text().trim();
					if (label) {
						$(this).attr('placeholder', label);
					}
				});
			}
		});
	},

	/** @description Bind Events */
	formMove: function() {
		this.$domInputTextarea.each(function() {
			if ($(this).val().length !== 0) { //In case there is a preloaded value
				FormLabel.getInputLabel(this).addClass(FormLabel.classMoved);
			} else {
				FormLabel.getInputLabel(this).removeClass(FormLabel.classMoved);
			}
		});

		this.$domCF7.on('focus', '.select2-selection, input, textarea', function() { //On focus move the label
			FormLabel.getInputLabel(this).addClass(FormLabel.classMoved);
		});
		this.$domCF7.on('blur', '.select2-selection, input, textarea', function() {
			if ($(this).val().length === 0 && !$(this).find('.select2-selection__rendered').attr('title')) {
				FormLabel.getInputLabel(this).removeClass(FormLabel.classMoved);
			}
		});
	},

	getInputLabel: function(selector) {
		return $(selector).parents(this.slWrapperInput).find(this.slInputLabel);
	},

	formAutofill: function() {
		FormLabel.$domInputTextarea.attr('autocomplete', 'negative');
	},
};

export default FormLabel;
